import { render, staticRenderFns } from "./prizeintegral.vue?vue&type=template&id=44998b7c&scoped=true"
import script from "./prizeintegral.vue?vue&type=script&lang=js"
export * from "./prizeintegral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44998b7c",
  null
  
)

export default component.exports